export default "__VITE_ASSET__Bh6AXYAC__"